import React from 'react';
import ListK1 from '../../components/spravochniki/k1/ListK1'

function Page(props) {
    return (
        <>
          <ListK1 />
        </>
    );
}

export default Page;